module.exports = __webpack_public_path__ + "static/ac-with-filter-50c54e3727599cb7fb6b7f83b80336df.jpg";